var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.501018 4.46044C3.79492 7.25002 9.5747 12.1577 11.2735 13.688C11.5015 13.8945 11.7461 13.9995 12 13.9995C12.2534 13.9995 12.4976 13.8955 12.7251 13.6899C14.4253 12.1582 20.2051 7.25002 23.4991 4.46044C23.7041 4.28709 23.7354 3.98241 23.5694 3.77048C23.1856 3.28078 22.6133 3 22 3H2.00003C1.38677 3 0.814471 3.28078 0.430706 3.77053C0.264674 3.98241 0.29594 4.28709 0.501018 4.46044Z",
    fill: "#4F565E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 5.9724C23.5327 5.8899 23.3242 5.91868 23.1768 6.04468C19.5239 9.14133 14.8618 13.1106 13.395 14.4323C12.5717 15.1755 11.4292 15.1755 10.604 14.4314C9.0405 13.0227 3.80512 8.57199 0.823219 6.04463C0.674766 5.91863 0.465797 5.89083 0.290016 5.97235C0.113297 6.05443 0 6.23119 0 6.426V19.0002C0 20.1033 0.896953 21.0002 2.00002 21.0002H22C23.103 21.0002 24 20.1033 24 19.0002V6.426C24 6.23119 23.8867 6.05396 23.71 5.9724Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.e604bf3246830da72f1f8b968e7c8883.svg";
export { ForwardRef as ReactComponent };